/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
$(document).ready(function () {
  var swatchHoverCfg = window.deskSwatchHover || {};
  var swatchHoverItems = swatchHoverCfg.items || [];

  var swatchHoverBtn = ".product_selection-all-box .pp_variants .pp_selection_color_btn";
  var swatchHoverDesktop = "(min-width: 800px) and (hover: hover)";
  var swatchHoverGap = 8;
  var swatchHoverEdge = 12;

  var swatchHoverFlagged = false;
  var swatchHoverPreloaded = false;
  var swatchHoverBox = null;
  var swatchHoverImg = null;
  var swatchHoverLabel = null;
  var swatchHoverCurrent = null;
  var swatchHoverSuppressed = null;
  var swatchHoverWasDesktop = window.matchMedia(swatchHoverDesktop).matches;
  var swatchHoverCloseTimer = null;

  $(window).on("desk:swatch-hover-test", function () {
    swatchHoverFlagged = true;
    swatchHoverActive();
  });

  function swatchHoverIsDesktop() {
    return window.matchMedia(swatchHoverDesktop).matches;
  }

  function swatchHoverActive() {
    var on =
      (window.DESK_SWATCH_HOVER_TEST === true || swatchHoverFlagged) &&
      swatchHoverIsDesktop();
    $("html").toggleClass("desk-swatch-hover-active", on);
    if (on) swatchHoverPreload();
    return on;
  }

  function swatchHoverPreload() {
    if (swatchHoverPreloaded) return;
    swatchHoverPreloaded = true;

    $.each(swatchHoverItems, function (i, item) {
      if (!item.image) return;
      var img = new Image();
      img.src = item.image;
    });
  }

  function swatchHoverItemFor($btn) {
    var index = String($btn.attr("data-index") || "");
    var value = String($btn.attr("data-value") || "");
    var found = null;

    $.each(swatchHoverItems, function (i, item) {
      if (String(item.index) === index && item.value === value) {
        found = item;
        return false;
      }
    });

    return found;
  }

  function swatchHoverBuild() {
    if (swatchHoverBox) return;

    swatchHoverBox = $(
      '<div class="desk-swatch-hover">' +
        '<img class="desk-swatch-hover__img" alt="" aria-hidden="true">' +
        '<span class="desk-swatch-hover__label"></span>' +
        "</div>"
    );
    swatchHoverImg = swatchHoverBox.find(".desk-swatch-hover__img");
    swatchHoverLabel = swatchHoverBox.find(".desk-swatch-hover__label");
    $("body").append(swatchHoverBox);

    swatchHoverBox.on("mouseenter", swatchHoverKeepOpen);
    swatchHoverBox.on("mouseleave", swatchHoverScheduleHide);
  }

  function swatchHoverKeepOpen() {
    clearTimeout(swatchHoverCloseTimer);
  }

  function swatchHoverScheduleHide() {
    clearTimeout(swatchHoverCloseTimer);
    swatchHoverCloseTimer = setTimeout(swatchHoverHide, 120);
  }

  function swatchHoverPlace($btn) {
    var rect = $btn.get(0).getBoundingClientRect();
    var w = swatchHoverBox.outerWidth();
    var h = swatchHoverBox.outerHeight();

    var left = rect.left + rect.width / 2 - w / 2;
    var maxLeft = $(window).width() - w - swatchHoverEdge;
    if (left > maxLeft) left = maxLeft;
    if (left < swatchHoverEdge) left = swatchHoverEdge;

    var top = rect.top - h - swatchHoverGap;
    if (top < swatchHoverEdge) top = rect.bottom + swatchHoverGap;

    swatchHoverBox.css({ left: Math.round(left) + "px", top: Math.round(top) + "px" });
  }

  function swatchHoverLabelFor($btn) {
    var text = $btn.attr("data-option-title") || "";
    if ($btn.hasClass("soldOut")) {
      var soldout = $.trim($btn.find(".pp_selection_label--soldout").text());
      if (soldout) text = soldout;
    }
    return text;
  }

  function swatchHoverShow($btn, item) {
    var text = swatchHoverLabelFor($btn);

    swatchHoverBuild();

    if (item && item.image) {
      swatchHoverImg.attr("src", item.image).show();
      swatchHoverBox.css({ "background-image": "", "background-color": "" });
    } else {
      var $bubble = $btn.find(".pp_selection_color_bubble");
      swatchHoverImg.hide().removeAttr("src");
      swatchHoverBox.css({
        "background-image": $bubble.css("background-image"),
        "background-color": $bubble.css("background-color")
      });
    }

    swatchHoverLabel.text(text);
    swatchHoverPlace($btn);
    swatchHoverBox.addClass("is-visible");
    swatchHoverCurrent = $btn.get(0);

    $(window).on("scroll.deskSwatchHover", function () {
      if (swatchHoverCurrent) swatchHoverPlace($(swatchHoverCurrent));
    });
  }

  function swatchHoverHide() {
    clearTimeout(swatchHoverCloseTimer);
    swatchHoverCurrent = null;
    $(window).off("scroll.deskSwatchHover");
    if (swatchHoverBox) swatchHoverBox.removeClass("is-visible");
  }

  function swatchTipActive() {
    return (
      (window.DESK_SWATCH_HOVER_TEST === true || swatchHoverFlagged) &&
      !swatchHoverIsDesktop()
    );
  }

  function swatchTipHide() {
    $(swatchHoverBtn + ".is-tip-open").removeClass("is-tip-open");
  }

  function swatchTipWatchViewport() {
    var scope = $(swatchHoverBtn).first().closest(".pp_variants").get(0);
    if (!scope || typeof IntersectionObserver === "undefined") return;

    new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting) swatchTipHide();
    }).observe(scope);
  }

  $(document).on("mouseenter", swatchHoverBtn, function () {
    if (!swatchHoverItems.length) return;
    swatchHoverKeepOpen();
    if (this === swatchHoverCurrent || this === swatchHoverSuppressed) return;
    if (!swatchHoverActive()) return;

    swatchHoverShow($(this), swatchHoverItemFor($(this)));
  });

  $(document).on("mouseleave", swatchHoverBtn, function () {
    if (this === swatchHoverSuppressed) swatchHoverSuppressed = null;
    if (this === swatchHoverCurrent) swatchHoverScheduleHide();
  });

  $(document).on("click", function (e) {
    swatchTipHide();
    if (!swatchTipActive()) return;

    var $btn = $(e.target).closest(swatchHoverBtn);
    if ($btn.length) $btn.addClass("is-tip-open");
  });

  $(document).on("keydown", function (e) {
    if (e.key !== "Escape" && e.keyCode !== 27) return;
    swatchTipHide();
    if (!swatchHoverCurrent) return;
    swatchHoverSuppressed = swatchHoverCurrent;
    swatchHoverHide();
  });

  $(window).on("resize", function () {
    var isDesktop = swatchHoverIsDesktop();

    swatchHoverActive();

    if (isDesktop !== swatchHoverWasDesktop) {
      swatchHoverWasDesktop = isDesktop;
      swatchTipHide();
    }

    if (!swatchHoverCurrent) return;
    if (isDesktop) swatchHoverPlace($(swatchHoverCurrent));
    else swatchHoverHide();
  });

  $(window).on("load", swatchHoverActive);

  swatchHoverActive();
  swatchTipWatchViewport();
});
